import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/statistics/PaymentFunction/index",{
        params: {
          ...params
        }
    } )
}
function EXPORT(params) {
    return  axios.get("/statistics/PaymentFunction/export",{
        params: {
            ...params
        }
    }  )
}

export default {
    GET_LIST,
    EXPORT,
};
